import MapLegend from './MapLegend';

export default MapLegend;
